import { combineReducers } from 'redux'

import brandConfig from 'brandConfig'
import { AUTH_ACTION } from '../../constants/actions'

const features = brandConfig.features

const resolveReducerImports = () =>
  Promise.all([
    import('./auth'),
    import('./main'),
    import('./account'),
    import('./transactions'),
    import('./rewards'),
    import('./exchange'),
    import('./nft'),
    import('./cashback'),
    import('./wallet'),
    import('./quest'),
    import('./game'),
    import('./earnVia'),
    import('./referral'),
    features.homeBanners ? import('./banners') : null,
    features.staking ? import('./staking') : null,
    features.rewardBoxes ? import('./rewardBox') : null
  ])

const getRootReducer = async () => {
  const reducers = await resolveReducerImports()
  const extractedReducers = reducers
    .filter(Boolean)
    .reduce((rootReducer, module) => {
      const propertyKey = Object.getOwnPropertyNames(module)[1]
      rootReducer[propertyKey] = module[propertyKey]
      return rootReducer
    }, {})

  const combinedReducer = combineReducers({
    ...extractedReducers
  })

  // Return a root reducer that resets the state on SIGN_OUT_SUCCESS
  return (state, action) => {
    if (action.type === AUTH_ACTION.ON_SIGN_OUT_SUCCESS) {
      state = undefined
    }
    return combinedReducer(state, action)
  }
}

export { getRootReducer }
